import React from 'react';
import { PageTitle } from '../components/PageTitle';
import { CaseStudyCard } from '../components/CaseStudyCard';
import { Helmet } from 'react-helmet-async';
import { TrendingUpIcon, BarChart2Icon, MailIcon, BrainIcon, LightbulbIcon, ClipboardCheckIcon } from 'lucide-react';
export function Portfolio() {
  const allCaseStudies = [{
    id: '1',
    title: 'AI-Driven FinTech Platform',
    description: 'Ideated vision, design and product roadmap of new AI-driven interactive FinTech platform that translates SMB seller data into personalized business recommendations.',
    metrics: ['AI/ML integration', '+24% program adoption', '$145M projected growth'],
    skills: ['Product Vision', 'Product Roadmapping'],
    icon: BrainIcon,
    iconColor: '#0096B4',
    iconBgColor: '#E0F5F8'
  }, {
    id: '2',
    title: 'DTC Product Selection Quiz',
    description: 'Rebuilt DTC product selection quiz by analyzing consumer path-to-purchase, optimizing the algorithm, and leading a UX/UI redesign.',
    metrics: ['+43% conversion lift', '98% completion rate', '+185% engagement'],
    skills: ['Product Design', 'UX/UI Development'],
    icon: ClipboardCheckIcon,
    iconColor: '#0096B4',
    iconBgColor: '#E0F5F8'
  }, {
    id: '3',
    title: 'Product Turnaround Strategy',
    description: 'Drove turnaround of $110M product platform from -12% decline to +9% growth in 6 months via organic growth plan.',
    metrics: ['+21% growth swing', '$110M product platform', '6-month timeframe'],
    skills: ['Problem-Solving', 'Consumer Insights'],
    icon: TrendingUpIcon,
    iconColor: '#0096B4',
    iconBgColor: '#E0F5F8'
  }, {
    id: '4',
    title: 'Product Innovation & Development',
    description: 'Rebuilt a pre-launch product with low retailer buy-in by co-creating with 32 key opinion leaders (KOLs), driving a 180° turnaround.',
    metrics: ['2-week timeframe', '$7M incremental sales', '32 KOL collaborations'],
    skills: ['Product Development', 'User Research'],
    icon: LightbulbIcon,
    iconColor: '#0096B4',
    iconBgColor: '#E0F5F8'
  }, {
    id: '5',
    title: 'CRM Program Development',
    description: "Built Neutrogena's CRM program, fueling +236% traffic and +53% growth ($540M impact).",
    metrics: ['+236% traffic increase', '+53% growth', '$540M commercial impact'],
    skills: ['Data Analytics', 'A/B Testing'],
    icon: MailIcon,
    iconColor: '#0096B4',
    iconBgColor: '#E0F5F8'
  }, {
    id: '6',
    title: 'Go-to-Market Strategy',
    description: 'Spearheaded new GTM strategy, driving 93% trial-to-purchase conversion and record quarterly pipeline.',
    metrics: ['93% conversion rate', 'Record quarterly pipeline', 'New GTM approach'],
    skills: ['Go-to-Market Strategy', 'Product Launch'],
    icon: BarChart2Icon,
    iconColor: '#0096B4',
    iconBgColor: '#E0F5F8'
  }];
  return <div data-id="element-1370">
      <PageTitle title="Portfolio" canonical="/portfolio" description="Explore Katalina Bock's portfolio showcasing product management, growth strategies, and cross-functional leadership across diverse industries." keywords="product management portfolio, growth strategies, cross-functional leadership, case studies, product turnaround, go-to-market strategy, CRM program" data-id="element-1371" />
      <Helmet data-id="element-1372">
        <script type="application/ld+json" data-id="element-1373">
          {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: "Katalina Bock's Portfolio",
          description: "Explore Katalina Bock's portfolio showcasing product management, growth strategies, and cross-functional leadership across diverse industries.",
          mainEntity: {
            '@type': 'ItemList',
            itemListElement: allCaseStudies.map((study, index) => ({
              '@type': 'ListItem',
              position: index + 1,
              url: `https://katalinabock.com/case-study-${study.id}`,
              name: study.title
            }))
          }
        })}
        </script>
      </Helmet>
      <section className="bg-gradient-to-r from-[#E0F5F8] to-[#F0FAFC] text-gray-900 py-16" data-id="element-1374">
        <div className="container mx-auto px-4" data-id="element-1375">
          <h1 className="text-4xl font-bold mb-4" data-id="element-1376">My Portfolio</h1>
          <p className="text-xl text-gray-700 max-w-3xl" data-id="element-1377">
            Explore some of my favorite projects showcasing product management,
            growth strategies, and cross-functional leadership across diverse
            industries and challenges.
          </p>
        </div>
      </section>
      <section className="py-16 bg-white" data-id="element-1378">
        <div className="container mx-auto px-4" data-id="element-1379">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1380">
            {allCaseStudies.map(caseStudy => <CaseStudyCard key={caseStudy.id} id={caseStudy.id} title={caseStudy.title} description={caseStudy.description} metrics={caseStudy.metrics} skills={caseStudy.skills} icon={caseStudy.icon} iconColor={caseStudy.iconColor} iconBgColor={caseStudy.iconBgColor} data-id="element-1381" />)}
          </div>
        </div>
      </section>
    </div>;
}